import { signalStoreFeature, withComputed, withMethods } from '@ngrx/signals';
import { IUser } from '@dxp/core/models';
import { IUserStore } from './user.public';

export function withUser(userStore: IUserStore) {
    return signalStoreFeature(
        withComputed(() => ({
            user: userStore.user,
        })),
        withMethods(() => ({
            updateUser: (user: IUser) => userStore.updateUser(user),
        })),
    );
}
